import { useTranslation } from 'react-i18next';
import { FilterPopover } from 'src/components/molecules/filter-popover';
import { HandleChangeFilterValue } from 'src/types/handle-change-filter-value';
import { FilterGroup } from 'src/types/interfaces/filter-group';
import { Filters } from 'src/types/interfaces/filters';
import { getSelectedFilters } from 'src/utils/filters/get-selected-filters';
import { toggleFilterItemSelection } from 'src/utils/filters/toggle-filter-item-selection';
import { invitationStateTranslations } from '../../../constants/employee-invitation-status';
import { EmployeeInvitationStatus } from '../../../types/enum/employee-invitation-status';

interface Props {
  filters: Filters;
  handleChangeFilterValue: HandleChangeFilterValue;
}

export const EmployeeStatusFilterPopover = ({
  filters,
  handleChangeFilterValue,
}: Props) => {
  const { t } = useTranslation();

  const filterGroup: FilterGroup<EmployeeInvitationStatus> = {
    id: 1,
    type: 'status',
    label: t('employees:employees.status'),
    singleOption: false,
    items: [
      {
        label: t(
          invitationStateTranslations[EmployeeInvitationStatus.COMPLETED],
        ),
        value: EmployeeInvitationStatus.COMPLETED,
      },
      {
        label: t(invitationStateTranslations[EmployeeInvitationStatus.INVITED]),
        value: EmployeeInvitationStatus.INVITED,
      },
    ],
  };

  return (
    <FilterPopover
      title={filterGroup.label}
      withStatusBadge
      selected={getSelectedFilters(filters, filterGroup.type)}
      onChange={option => {
        toggleFilterItemSelection(
          filterGroup.type,
          option,
          filterGroup.singleOption,
          filters,
          handleChangeFilterValue,
          filterGroup.filterOperator,
        );
      }}
      options={filterGroup.items.map(item => ({
        label: item.label,
        value: item.value,
      }))}
    />
  );
};
